import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_STA002_Request,
  IAPI_STA002_Response,
} from "../../../type/apiType";

// 退職者状況管理一覧参照
const httpAPI_STA002 = async (
  param: IAPI_STA002_Request
): Promise<IAPI_STA002_Response> => {
  let res = await http.post(ApiUrl.API_STA002, {
    ...param,
  });
  return res.data;
};

export { httpAPI_STA002 };
